import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/Axelerate_logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-4c9e1e6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "min-h-screen flex flex-col items-center justify-center rounded bg-background" }
const _hoisted_2 = { class: "flex flex-col bg-white shadow px-4 sm:px-6 md:px-8 lg:px-10 pt-8 rounded-2xl w-full max-w-md" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "login logo",
  style: {"width":"42%"},
  class: "lg:pb-5 pt-8"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold self-start text-xl sm:text-2xl text-gray pt-5" }, " Login to Axelerate ", -1))
const _hoisted_5 = { class: "pt-10" }
const _hoisted_6 = { class: "flex flex-col mb-6" }
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = { class: "flex flex-col mb-6" }
const _hoisted_9 = { class: "relative z-0 w-full mb-2" }
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = { class: "flex justify-between align-middle mb-6 mt-4" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "block ml-auto" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inline-flex sm:text-sm text-primary font-medium" }, "Forgot Password?", -1))
const _hoisted_15 = { class: "flex w-full pb-10 pt-5" }
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_PasswordField = _resolveComponent("PasswordField")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_TextField, {
                modelValue: _ctx.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                label: "Email",
                typeInput: "email",
                rule: "required|email",
                helperErrorText: "Email is required.",
                name: "email"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_PasswordField, {
                  modelValue: _ctx.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                  label: "Password",
                  rule: "required",
                  helperErrorText: "Password is required.",
                  name: "password"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_CheckBox, {
                fieldId: "remember",
                checked: _ctx.remember,
                "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.remember) = $event)),
                label: "Remember me"
              }, null, 8, ["checked"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_router_link, { to: "/recovery-password" }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              type: "submit",
              disabled: !_ctx.meta.dirty || !_ctx.meta.valid,
              class: "flex items-center justify-center focus:outline-none text-white text-sm sm:text-base bg-primary rounded-full py-2 w-full transition duration-150 ease-in h-14 btn-submit"
            }, " Log In ", 8, _hoisted_16)
          ])
        ], 32)
      ])
    ])
  ]))
}